<div class="d-flex position-relative">
  <div *ngIf="showCount"
      class="more-count position-absolute fw-medium"
      [style.left.px]="showingDisplay * notOverlapSize"
      [style.width.px]="size"
      [style.height.px]="size"
      [style.font-size.px]="fontSize || size * 0.5"
      [style.background]="'#BDBFC7'"
      [style.border-color]="'#BDBFC7'">
    +{{ count - showingDisplay }}
  </div>
  <ng-container *ngFor="let display of _displayList; let index=index">
    <div class="position-absolute"
        [style.left.px]="(_displayList.length - 1 - index) * notOverlapSize">
      <ng-container [ngSwitch]="display.unit">
        <app-profile-display *ngSwitchCase="'person'"
            [person]="display.display"
            [borderColor]="'#EAEAED'"
            [size]="size"
            [fontSize]="fontSize || size * 0.5"></app-profile-display>
        <app-profile-display *ngSwitchCase="'department'"
            [borderColor]="'#EAEAED'"
            [size]="size"
            [person]="display.display"
            [defaultPhoto]="'assets/images/default-dept.png'"
        ></app-profile-display>
      </ng-container>
    </div>
  </ng-container>
</div>